import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { SharedModule } from 'app/shared/shared.module';
import { NofeshPnimCanActivateGuard } from 'app/shared/guards/nofesh-pnim-can-activate.guard';
import { NofeshPnimRouting } from '../nofesh-pnim.routes';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    BrowserModule,
    SharedModule,
    NofeshPnimRouting
  ],
  providers : [NofeshPnimCanActivateGuard]
})
export class NofeshPnimModule { }
